import { Component } from '@angular/core';
import { ModalController, Platform, NavParams, ViewController } from 'ionic-angular';
import { datos } from '../../providers/datos';
import { NavController} from 'ionic-angular';
import { Modal } from '../modal/modal';
import { direcciones } from '../direcciones/direcciones';

import { tarjetas } from '../tarjetas/tarjetas';

import { ActionSheetController } from 'ionic-angular';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Login } from '../login/login';

import { Geolocation } from '@ionic-native/geolocation';

declare var cordova:any;
declare var document:any;
declare var window:any;
declare var jQuery:any;
declare var $:any;
declare var swal:any ;
@Component({
  selector: 'detalle',
  templateUrl: 'detalle.html',
})
export class Detalle {

menu="hoy";
total=0;
  constructor(   
  public viewCtrl: ViewController,
  public params: NavParams,
  private datos:datos,
  public navCtrl: NavController,
  public modalCtrl: ModalController,
  public actionSheetCtrl: ActionSheetController,
  private geolocation: Geolocation



   ) {

    this.sacarTotal();
    this.datos.pedido.pago.text="EFECTIVO";
    this.datos.pedido.pago.id="0";
    
    // this.producto= this.params.get('producto');

    // console.log( this.producto);

  }

  ionViewDidLoad() {
    this.sacarTotal();

  }



  add(i){
    console.log(i);
    this.datos.pedido.items[i].cantidad ++;
    this.RecalcularPrecio(i);

  }

  modal(item?) {
    console.log("modal");
    let modal = this.modalCtrl.create(Modal,{"item":item },{cssClass: "transactionConfirm-modal"});
    modal.present();
  
  }

  openDireciones(){
    
      console.log("modal");
      let modal = this.modalCtrl.create(direcciones,{"item":"item" },{cssClass: "transactionConfirm-modal"});
      modal.present();
    
    
  }

  tarjetas(item?) {
    console.log("tarjetas");
    let modal = this.modalCtrl.create(tarjetas,{"item":item },{cssClass: "transactionConfirm-modal"});
    modal.present();
  
  }




  
  rm(i){
    if( (this.datos.pedido.items[i].cantidad -1) >0){
      this.datos.pedido.items[i].cantidad --;
    
    }
    this.RecalcularPrecio(i);

  }


RecalcularPrecio(i){
  console.log(this.datos.pedido.items[i].valor );
  console.log(this.datos.pedido.items[i].cantidad );

    this.datos.pedido.items[i].total =this.datos.pedido.items[i].valor * this.datos.pedido.items[i].cantidad;
    this.sacarTotal();
  
  
}


del(item){
  let i  = this.datos.pedido.items.indexOf(item);
  if(i > -1){
    this.datos.pedido.items.splice(i, 1);
    this.sacarTotal();
  }


  if (this.datos.pedido.items.length <1) {
    this.cancel();
    this.sacarTotal();

  }


}

cancel(){
  
  this.viewCtrl.dismiss({dato:0});

}


sacarTotal(){
  this.total=0;
  for (let i = 0; i <this.datos.pedido.items.length; i++) {
    this.total = this.datos.pedido.items[i].total+this.total;
    
  }
}
  dismiss(){
    this.viewCtrl.dismiss();

  }

confirmar(){


  if (this.total<9.99){
    this.datos.Toast("Pedido debe ser mayor a $10 dolares!!",2000);
}

else 

if (!this.datos.pedido.fecha.length){
    this.datos.Toast("Verificar Fecha !!",2000);
}

else if (!this.datos.pedido.hora.length){
  this.datos.Toast("Verificar hora!!",2000);

}

else if (!this.datos.pedido.pago.text.length){
  this.datos.Toast("Debe escojer tipo de pago!!",2000);

}

else if (!this.datos.pedido.direccion.text.length){
  this.datos.Toast("Debe escojer la dirección!!",2000);

}

else if (!this.datos.login.login){
  this.datos.Toast("Login !",500);

  setTimeout(() => {
      this.navCtrl.push(Login);
  }, 500);

}


else {
//  alert();

setTimeout(() => {
  this.datos.notificacion("SERVICIO OCRE ACEPTADO");
  
}, 30000);
swal({
  title: "Reserva registrada",
  text: "Debes esperar la confirmacion del especialista",
  icon: "success",
  confirmButtonColor:"red",
  buttons: {
       
    defeat: {
      text:"Hacer otro Pedido",
      value:"ok"
    },
  },
})
.then((value) => {

  switch (value) {                         
 
    case "ok":
    this.cancel();
    break;
    default:
    console.log("cancelado");
  }
});

 this.datos.reset();


}


}


selectPago() {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'SELECCIONAR TIPO DE PAGO:',
    buttons: [
      {
        text: 'EFECTIVO',
        role: 'destructive',
        icon: 'ios-cash',
        handler: () => {
          // this.datos.pagos.text="EFECTIVO";
          this.datos.pedido.pago.text="EFECTIVO";
          this.datos.pedido.pago.id="0";
          console.log('Destructive clicked');
        }
      }
      // ,{
      //   text: 'TARJETA DE CREDITO',
      //   icon:'ios-card',
      //   handler: () => {
      //     // this.datos.pagos.text="TARJETA DE CREDITO";
      //     this.datos.pedido.pago.text="TARJETA DE CREDITO";
      //     this.datos.pedido.pago.id="1";

      //     console.log('Archive clicked');
      //     this.tarjetas();
      //   }
      
      // }
    ]
  });
  actionSheet.present();
}


getGps(){
  this.datos.loader(1);

  this.geolocation.getCurrentPosition().then((resp) => {
    this.datos.loader(0);
    this.datos.Toast("lat:"+resp.coords.latitude + "lon:" + resp.coords.longitude,2000);
      return "lat:"+resp.coords.latitude + "lon:" + resp.coords.longitude
   }).catch((error) => {
     console.log('Error getting location', error);
    this.datos.loader(0);
    this.datos.Toast("UBICACIÓN NO ENCONTRADA",2000);


   })
}
selectDir() {

  let buttons = [
    {
      text: 'AÑADIR NUEVA',
      role: 'destructive',
      icon: 'ios-map',
      handler: () => {
        // this.datos.pagos.text="EFECTIVO";
       this.openDireciones();
        this.datos.pedido.pago.text="EFECTIVO";
        this.datos.pedido.pago.id="0";
        console.log('Destructive clicked');
      }
    }
  ];

  buttons.push(
    {
      text: "MI UBICACION ACTUAL (GPS)",
      role: 'destructive',
      icon: 'ios-pin',
      handler: () => {
        this.datos.pedido.direccion.text="GPS";
        // this.datos.pedido.pago.id="0";
        this.getGps();
        console.log('Destructive clicked');
      }
    });



 for (let index = 0; index< this.datos.direcciones.length; index++) {
        buttons.push(
          {
            text: this.datos.direcciones[index].nombre,
            role: 'destructive',
            icon: 'ios-pin',
            handler: () => {
              this.datos.pedido.direccion.text=this.datos.direcciones[index].nombre;
              // this.datos.pedido.pago.id="0";
              console.log('Destructive clicked');
            }
          }




        );
   
 }



  const actionSheet = this.actionSheetCtrl.create({
    title: 'SELECCIONAR DIRECCIÓN:',
    buttons:buttons

  });
  actionSheet.present();
}

}


// WEBPACK FOOTER //
// ./src/pages/detalle/detalle.ts